module.exports = __webpack_public_path__ + "img/GENERAL-CIAZ-3.1341f5b3.jpg";